import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { RouterProvider } from 'react-router-dom';
import {router} from "./App"
import * as Sentry from "@sentry/react";
import ErrorBoundary from './components/ErrorBoundary';

const apiUrl = (process.env.REACT_APP_API_URL || '').trim().replace(/\/$/, '');

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  environment: process.env.REACT_APP_ENVIRONMENT || 'production',
  release: process.env.REACT_APP_VERSION,
  sendDefaultPii: true,

  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],

  // Capture 20% of transactions for performance monitoring (tune per environment)
  tracesSampleRate: parseFloat(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE || '0.2'),

  // Propagate Sentry trace headers to the Jimani API so back-end errors link to front-end traces
  tracePropagationTargets: [
    'localhost',
    ...(apiUrl ? [new RegExp(`^${apiUrl.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}`)] : []),
  ],

  // Record 10% of sessions; always record sessions where an error occurred
  replaysSessionSampleRate: parseFloat(process.env.REACT_APP_SENTRY_REPLAY_SAMPLE_RATE || '0.1'),
  replaysOnErrorSampleRate: parseFloat(process.env.REACT_APP_SENTRY_REPLAY_ERROR_SAMPLE_RATE || '1.0'),
});
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <ErrorBoundary >
   <RouterProvider router={router} />
   </ErrorBoundary>
  // </React.StrictMode>
);
reportWebVitals();
